import React, { FC } from 'react';
import styled from 'styled-components';
import { MomentType } from '@generated/types';
import { OParagraph, OSmallParagraph } from '@lifechurch/react-ion';
import { useRouter } from 'next/router';

interface Props {
  type: MomentType;
  title: string;
  subtitle?: string;
}

const Wrapper = styled.div`
  min-height: 80px;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.action.light};
  padding: 8px 12px;
  border-radius: ${props => props.theme.radii[1]}px;
  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.action.light};

    p {
      color: ${props => props.theme.colors.action.hover};
    }
  }
`;

const AddMomentTemplate: FC<Props> = ({ subtitle, title, type }) => {
  const router = useRouter();
  return (
    <Wrapper
      onClick={() =>
        router.push({
          pathname: '/moment/new',
          query: { type },
        })
      }
    >
      <OParagraph color='action.default' fontWeight={3}>
        {title}
      </OParagraph>
      {subtitle && <OSmallParagraph>{subtitle}</OSmallParagraph>}
    </Wrapper>
  );
};

export { AddMomentTemplate };
